/** @file Every default editor binding (bindings.ts + panel and tool tables), for validateTable checks only. */
import type { Binding } from '@pose2d/shortcuts/types';
import { BINDINGS } from '../../bindings.gen';
import { PANELS } from '../../panels.gen';
import { TOOLS } from '../../tools.gen';

/** Deduplicated by identity (a panel may list the same table its bindings.ts exports). */
export function allBindings(): Binding[] {
  const tables: readonly (readonly Binding[])[] = BINDINGS;
  const panels: readonly { bindings: readonly Binding[] }[] = PANELS;
  const tools: readonly { bindings: readonly Binding[] }[] = TOOLS;
  return [...new Set([...tables.flat(), ...panels.flatMap((p) => p.bindings), ...tools.flatMap((t) => t.bindings)])];
}
